import { auth } from "../type";

const getIntialFuction = ()=>{
    if(localStorage.getItem("token")){ 
        return {
            "signIn" : true,
            "token" : localStorage.getItem("token"),
            "user" : JSON.parse(localStorage.getItem("user")),
        };
    }
    return {
        "signIn" : false,
        "token" : "",
        "user" : "",
    };     

}

const INITIAL_STATE = getIntialFuction();

const LoginReducer = (state = INITIAL_STATE, action)=>{
    if(action.type === auth.login){
        // console.log("Reducer",action.payload);
        localStorage.setItem("user", JSON.stringify(action.payload))
        // localStorage.setItem("userData", JSON.stringify(action.payload))
        state={
            "signIn":true,
            "user":action.payload,
            
        }
    }
    else if(action.type === auth.logout){
        // console.log("Session Expires",action.payload);
        localStorage.clear();
        state={
            "signIn":false,
            "session":action.payload,
        }
    }
    return state;
}
export default LoginReducer 